import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useApplicationContext } from '~/shared/context/use-application-context';
import type { SkillDetails } from '~/shared/data-contract/skill-details';

import { useApplicationFetchers } from '../../../fetchers/use-application-fetchers';

const skillDetailsKey = (skillId: string, language: string) => ['skill-details', skillId, language] as const;

export const useSkillDetails = (skillId: string, language?: string): UseQueryResult<SkillDetails, Error> => {
    const { fetchSkillDetails } = useApplicationFetchers();
    const { applicationState } = useApplicationContext();
    const currentLanguage = applicationState.language;
    const languageToUse = language ?? currentLanguage.code;

    return useQuery({
        queryFn: async () => {
            const result = await fetchSkillDetails({ language: languageToUse, skillId });

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: skillDetailsKey(skillId, languageToUse),
        throwOnError: false,
    });
};
